export const applyAttr = (element, attr, value) => {
  const checkAttr = element.getAttribute(attr)
  if (checkAttr) return
  if (element && element.setAttribute) {
    element.setAttribute(attr, value)
  }
}
